jQuery( function ( $ ) {
    const url = new URL(window.location.href);
    $( '.js-prefRefine__prefButton' ).on( 'click', function() {
        const pref = $( this ).data( 'pref' );
        url.searchParams.set('pref', pref);
        window.location.href = url;
    } );

    $( '.js-prefRefine__release' ).on( 'click', function() {
        url.searchParams.delete('pref');
        window.location.href = url;
    } );
} );